var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{staticClass:"hm-switch-group",class:{
    'hm-switch-group--disabled': _vm.disabled,
  },scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var errors = ref.errors;
return [_c('label',{staticClass:"hm-switch",class:{
      'hm-switch--active': _vm.value,
    },attrs:{"for":("hm-switch-input-" + _vm.uid)}},[_c('span',{staticClass:"hm-switch-button"})]),_c('input',{staticClass:"hm-switch-checkbox",attrs:{"type":"checkbox","disabled":_vm.disabled,"id":("hm-switch-input-" + _vm.uid)},domProps:{"value":_vm.value},on:{"click":_vm.toggle}}),_c('span',{attrs:{"id":("error_" + _vm.uid)}},[_vm._v(_vm._s(errors[0]))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }